/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetByStateIdsOptsApiModel } from '../../models/get-by-state-ids-opts-api-model';
import { ListCountiesDbResponseDataModelApiModel } from '../../models/list-counties-db-response-data-model-api-model';

export interface GetByStates$Params {
      body: GetByStateIdsOptsApiModel
}

export function getByStates(http: HttpClient, rootUrl: string, params: GetByStates$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ListCountiesDbResponseDataModelApiModel>>> {
  const rb = new RequestBuilder(rootUrl, getByStates.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ListCountiesDbResponseDataModelApiModel>>;
    })
  );
}

getByStates.PATH = '/v1/counties/list';
